import "./AutoScaleText.css";

import { getWidthFromText } from '../../utils/ui';
import {useEffect, useState} from "react";

export default function AutoScaleText(props) {
  function font(size, fontFamily) {
    return `${size}px ${fontFamily}`
  }

  const minFontSizeInPx = props.minFontSizeInPx;
  const maxFontSizeInPx = props.maxFontSizeInPx;
  const fontFamily = props.fontFamily;
  const maxWidthInPx = props.maxWidthInPx;
  const text = props.children;

  const [style, setStyle] = useState({
    fontSize: minFontSizeInPx,
    fontFamily,
  });

  useEffect(() => {
    let optimalFontSize = minFontSizeInPx;
    for (let fontSize = minFontSizeInPx; fontSize < maxFontSizeInPx; fontSize++) {
      let contentWidthInPx = getWidthFromText(text, font(fontSize, fontFamily));
      if (contentWidthInPx > maxWidthInPx) {
        break;
      }
      optimalFontSize = fontSize;
    }
    console.log(optimalFontSize);
    setStyle({ fontSize: optimalFontSize, fontFamily });
  }, [minFontSizeInPx, maxFontSizeInPx, fontFamily, maxWidthInPx, text]);
  return (
    <span style={style}>
      { text }
    </span>
  );
}